import { connect } from 'react-redux';
import { toggleReactionToComment } from '../../redux/actionCreators';
var mapDispatchToProps = {
    toggleReactionToComment: toggleReactionToComment,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=ReactionList.container.js.map